package com.essntl.features.organization.ui.organizationdetails

import com.essntl.features.contact.domain.model.ContactModel
import com.essntl.features.file.domain.model.FileModel
import com.essntl.features.organization.domain.model.OrganizationModel
import com.mohamedrejeb.calf.core.PlatformContext

sealed interface OrganizationDetailsEvent {
    data class GetOrganization(val id: String) : OrganizationDetailsEvent
    data class UpdateContact(val contact: ContactModel) : OrganizationDetailsEvent
    data class DeleteContact(val contact: ContactModel) : OrganizationDetailsEvent
    data object LoadParentOrganizations : OrganizationDetailsEvent
    data class SearchParentOrganization(val query: String, val type: OrganizationModel.Type) : OrganizationDetailsEvent
    data class UpdateOrganizationFields(val organization: OrganizationModel) : OrganizationDetailsEvent
    data class UpdateParentOrganization(val organization: OrganizationModel) : OrganizationDetailsEvent
    data object EditOrganization : OrganizationDetailsEvent
    data class AddLogo(val file: FileModel, val context: PlatformContext) : OrganizationDetailsEvent
    data object DeleteLogo : OrganizationDetailsEvent
    data class InsertLogo(val context: PlatformContext) : OrganizationDetailsEvent
    data class SelectContact(val id: String) : OrganizationDetailsEvent
    data object ClearSuccessState : OrganizationDetailsEvent
    data class AddRemoveAddress(val addAddress: Boolean? = null) : OrganizationDetailsEvent
}